var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-container"},_vm._l((_vm.options),function(option){return _c('div',{key:option,staticClass:"tab-button",class:{ 'tab-selected': option === _vm.selected },on:{"click":function($event){return _vm.$emit('change', option)}}},[_vm._v("\n    "+_vm._s(option)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }